import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=6c046672&"
import script from "./SideNav.script.js?vue&type=script&lang=js&"
export * from "./SideNav.script.js?vue&type=script&lang=js&"
import style0 from "./SideNav.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports